import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import Icon from 'chameleon/ui-stack/ui/base/icon';

const SearchInput = (props) => {
  const {
    text,
    setText,
    isSearchTextEmpty,
    onInputKeyPress,
    onClearText,
    inputRef,
    className,
    inputClassName,
    inputPlaceholder,
  } = props;

  return (
    <div className={`h-12.2 relative flex-1 ${className}`}>
      <div className="absolute top-2 left-4">
        <Icon
          id="search"
          className="w-8 text-gray-500"
          accessibility={{ ariaHidden: true }}
        />
      </div>
      <input
        tabIndex={0}
        className={cn(
          'border border-gray-400 h-full w-full text-base pl-12.6',
          { 'pr-12.6': !isSearchTextEmpty },
          { 'pr-4': isSearchTextEmpty },
          inputClassName,
        )}
        type="text"
        value={text}
        onChange={(event) => setText(event.target.value)}
        onKeyPress={onInputKeyPress}
        placeholder={inputPlaceholder}
        ref={inputRef}
      />
      {!isSearchTextEmpty && (
        <ButtonWithIcon
          isIcon
          isNaked
          size="tiny"
          icon="remove_circle"
          accessibility={{ title: 'Clear Search' }}
          tabIndex={0}
          onClick={onClearText}
          className="absolute top-1.5 right-2"
          iconClassName="text-gray-500"
        />
      )}
    </div>
  );
};

SearchInput.propTypes = {
  text: PropTypes.string.isRequired,
  setText: PropTypes.func.isRequired,
  isSearchTextEmpty: PropTypes.bool.isRequired,
  onInputKeyPress: PropTypes.func.isRequired,
  onClearText: PropTypes.func.isRequired,
  //@todo revisit - why it's func or object
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  inputPlaceholder: PropTypes.string,
};

SearchInput.defaultProps = {
  inputRef: () => {},
  className: '',
  inputClassName: '',
  inputPlaceholder: '',
};

export default SearchInput;
